## Minimal projection of a link, used to reproduce the sessions-editor tab gates
## inside the event details modal.
##
## Deliberately NOT reusing `CalendarSections`: that fragment pulls instructors,
## classrooms, courses, bundles and groups for every session, none of which this
## gate needs. Only three things are read here — whether a structure is applied,
## whether the course is eligible, and whether any assigned session has already
## started (which needs one time and one date per session, nothing else).
query linkProgrammingGate($scenarioId: ID!, $originId: ID!, $resourceId: ID!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    editorView(resourceType: LINK, resourceId: $resourceId) {
      info {
        ... on LinkInfo {
          link {
            id
            groups {
              id
              labels {
                id
                code
              }
            }
            programmingStructure {
              id
              code
              name
            }
            course {
              id
              courseType
            }
          }
        }
      }
      sections {
        id
        unasignedSessions {
          id
        }
        sessions {
          id
          assignment {
            blockRange {
              start {
                id
                startingTime
              }
            }
            intervals {
              id
              startingDate
            }
          }
        }
      }
    }
  }
}
